// extracted by mini-css-extract-plugin
export var callCard = "_p4-0";
export var callMessageButton = "_p4-1";
export var helpIcon = "_p4-3";
export var helpIconContainer = "_p4-4";
export var verticalDivider = "_p4-2";